// useBreadcrumbs.js
import { useMemo } from "react";
import { breadcrumbsMap } from "./breadcrumbsMap";
import { useTranslation } from "react-i18next";

export const useBreadcrumbs = (path:string) => {
  
    const { t } = useTranslation();
  
    return useMemo(() => {
        for (const [basePath, { head, subRoutes }] of Object.entries(breadcrumbsMap)) {
        if (path.startsWith(basePath)) {
            let sub = "";
            for (const [regex, subKey] of Object.entries(subRoutes)) {
            if (new RegExp(regex).test(path)) {
                sub = t(subKey);
                break;
            }
            }

            return { main: t(head), sub };
        }
        }

        return { main: "", sub: "" }; // Default case
    }, [path, t]);
};
